import { render } from "./ProductsCard.vue?vue&type=template&id=5a8f3971&scoped=true"
import script from "./ProductsCard.vue?vue&type=script&lang=js"
export * from "./ProductsCard.vue?vue&type=script&lang=js"

import "./ProductsCard.vue?vue&type=style&index=0&id=5a8f3971&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8f3971"]])

export default __exports__